import { Container } from 'aurelia-dependency-injection';
import { I18N } from 'aurelia-i18n';

export interface IconStatusItem {
	class: string;
	title: string;
}

export enum IconStatusError {
	NONE = 0,
	WARNING = 1,
	ERROR = 2,
}

export function getNoteIconStatus(hasNote: boolean): IconStatusItem {
	const i18n: I18N = Container.instance.get(I18N);
	if (hasNote) {
		return {
			title: i18n.tr('acurity-table.notes-exist'),
			class: 'fas fa-sticky-note icon-status-list__icon--has-note',
		};
	} else {
		return {
			title: i18n.tr('acurity-table.no-notes'),
			class: 'fas fa-sticky-note',
		};
	}
}

export function getErrorOrWarningStatus(
	status: IconStatusError,
): IconStatusItem {
	const i18n: I18N = Container.instance.get(I18N);
	switch (status) {
		case IconStatusError.NONE:
			return {
				title: i18n.tr('acurity-table.no-error-or-warning-messages'),
				class: 'fas fa-exclamation-circle',
			};
		case IconStatusError.WARNING:
			return {
				title: i18n.tr('acurity-table.warning-messages'),
				class: 'fas fa-exclamation-circle icon-status-list__icon--has-warning',
			};
		case IconStatusError.ERROR:
			return {
				title: i18n.tr('acurity-table.error-messages'),
				class: 'fas fa-exclamation-circle icon-status-list__icon--has-error',
			};
		default:
			throw new Error('Invalid argument passed in: ' + status);
	}
}

export function IconStatusList(icons: IconStatusItem[]): string {
	let output: string = '';
	for (const icon of icons) {
		if (!icon.class) {
			// Hide icons with no classes.
			// This logic was implemented for the ZYc_Master_Child_Indicator field.
			continue;
		}
		output += `
			<span
				class="icon-status-list__readable-icon"
				title="${icon.title ? icon.title : ''}"
			>
				<i
					class="
						icon-status-list__icon
						${icon.class ? icon.class : ''}
					"
					aria-hidden="true"
				></i>
				<span class="sr-only">{icon.title}</span>
			</span>
		`;
	}
	if (!output) {
		return '';
	}
	output = '<div>' + output + '</div>';
	return output;
}
